'use client';

import CmsBlockGroup from '@/components/CmsBlock';
import { websiteEnv } from '@/constants/website-env';
import classes from './siteMapPage.module.css';

export const SiteMapPage = () => {
  const pageTitle = 'SITE MAP';

  return (
    <>
      <div className={classes.sitemap}>
        <h1 className={classes.title}>{pageTitle}</h1>
        <div className={classes.sitemaplist}>
          <CmsBlockGroup
            classes={{
              root: classes.con,
            }}
            identifiers={websiteEnv.isUnitedStates ? 'site-map' : 'site-map-english'}
            resolveRelativePath={!!process.env.NEXT_PUBLIC_BASE_PATH}
          />
        </div>
      </div>
    </>
  );
};

export default SiteMapPage;
